import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
// components
//
import { ReactNode, createContext, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import Main from './Main';
import './mobile-layout.css';

// ----------------------------------------------------------------------

type ContextType = {
  bodyMonted: boolean;
  setBodyMonted: (value: boolean) => void;
};
const Context = createContext({} as ContextType);

const Provider = ({ children }: { children: ReactNode }) => {
  const [bodyMonted, setBodyMonted] = useState(false);

  const state = useMemo(() => ({ bodyMonted, setBodyMonted }), [bodyMonted, setBodyMonted]);
  return <Context.Provider value={state}>{children}</Context.Provider>;
};

const useMobileLayoutContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useMobileLayoutContext must be used within a MobileLayoudContext');
  }
  return context;
};

export default function MobileLayout() {
  return (
    <Provider>
      <Box
        sx={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          minHeight: { lg: 1 },
        }}
      >
        <Main>
          <Outlet />
        </Main>
      </Box>
    </Provider>
  );
}

export const BottomContainer = ({ children }: { children: ReactNode }) =>
  createPortal(
    <Box
      id="bottom-container"
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
        zIndex: 1000,
        width: '100vw',
        maxWidth: '1000px',
      }}
    >
      {children}
    </Box>,
    document.getElementById('root')!
  );
